import { JsonApiDocumentInterface } from '../interfaces/json-api-document';
import { JsonApiResourceInterface } from '../interfaces/json-api-resource-interface';
import { JsonApiDocument } from './json-api-document';
import { JsonApiResource } from './json-api-resource';

export class JsonApiOneResourceDocument<
  R extends JsonApiResource
> extends JsonApiDocument<R> {
  constructor(document: JsonApiDocumentInterface<JsonApiResourceInterface>) {
    super(document);
    if (document.data) {
      const resource = this.createResource(document.data) as R;
      this._data = resource;

      if (document.included) {
        this._included = document.included.map((resource) =>
          this.createResource(resource)
        );
        this.populateResources(document);
      }
    }
  }
}
